/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateDepartmentRequest } from '../models/create-department-request';
import { DepartmentResponse } from '../models/department-response';
import { GenericResponse } from '../models/generic-response';
import { GetDepartmentResponse } from '../models/get-department-response';
import { GetDepartmentsOfLoggedInUserResponse } from '../models/get-departments-of-logged-in-user-response';
import { UpdateDepartmentRequest } from '../models/update-department-request';

/**
 * department apis
 */
@Injectable({ providedIn: 'root' })
export class DepartmentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllDepartments()` */
  static readonly GetAllDepartmentsPath = '/api/v1/departments';

  /**
   * get all departments.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllDepartments()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllDepartments$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields.
       * - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetDepartmentResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DepartmentService.GetAllDepartmentsPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetDepartmentResponse>;
        })
      );
  }

  /**
   * get all departments.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllDepartments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllDepartments(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields.
       * - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetDepartmentResponse> {
    return this.getAllDepartments$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<GetDepartmentResponse>): GetDepartmentResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `createDepartment()` */
  static readonly CreateDepartmentPath = '/api/v1/departments';

  /**
   * create new department.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDepartment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDepartment$Response(
    params: {
      body: CreateDepartmentRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DepartmentResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DepartmentService.CreateDepartmentPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<DepartmentResponse>;
        })
      );
  }

  /**
   * create new department.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDepartment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDepartment(
    params: {
      body: CreateDepartmentRequest;
    },
    context?: HttpContext
  ): Observable<DepartmentResponse> {
    return this.createDepartment$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<DepartmentResponse>): DepartmentResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `getDepartmentById()` */
  static readonly GetDepartmentByIdPath = '/api/v1/departments/{id}';

  /**
   * get department by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDepartmentById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDepartmentById$Response(
    params: {
      /**
       * The department id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DepartmentResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DepartmentService.GetDepartmentByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<DepartmentResponse>;
        })
      );
  }

  /**
   * get department by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDepartmentById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDepartmentById(
    params: {
      /**
       * The department id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<DepartmentResponse> {
    return this.getDepartmentById$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<DepartmentResponse>): DepartmentResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `disableDepartmentById()` */
  static readonly DisableDepartmentByIdPath = '/api/v1/departments/{id}';

  /**
   * disable department by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disableDepartmentById()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableDepartmentById$Response(
    params: {
      /**
       * The department id that needs to be soft deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DepartmentService.DisableDepartmentByIdPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * disable department by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disableDepartmentById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableDepartmentById(
    params: {
      /**
       * The department id that needs to be soft deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.disableDepartmentById$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateDepartmentById()` */
  static readonly UpdateDepartmentByIdPath = '/api/v1/departments/{id}';

  /**
   * update department by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDepartmentById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDepartmentById$Response(
    params: {
      /**
       * The department id that needs to be updated
       */
      id: number;
      body: UpdateDepartmentRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DepartmentResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DepartmentService.UpdateDepartmentByIdPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<DepartmentResponse>;
        })
      );
  }

  /**
   * update department by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDepartmentById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDepartmentById(
    params: {
      /**
       * The department id that needs to be updated
       */
      id: number;
      body: UpdateDepartmentRequest;
    },
    context?: HttpContext
  ): Observable<DepartmentResponse> {
    return this.updateDepartmentById$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<DepartmentResponse>): DepartmentResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `getAllDepartmentIdsOfLoggedInUser()` */
  static readonly GetAllDepartmentIdsOfLoggedInUserPath =
    '/api/v1/departments/users';

  /**
   * get departments of logged in user (ids or details).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllDepartmentIdsOfLoggedInUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllDepartmentIdsOfLoggedInUser$Response(
    params?: {
      /**
       * When true, returns full department details; otherwise only IDs.
       */
      details?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetDepartmentsOfLoggedInUserResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DepartmentService.GetAllDepartmentIdsOfLoggedInUserPath,
      'get'
    );
    if (params) {
      rb.query('details', params.details, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetDepartmentsOfLoggedInUserResponse>;
        })
      );
  }

  /**
   * get departments of logged in user (ids or details).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllDepartmentIdsOfLoggedInUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllDepartmentIdsOfLoggedInUser(
    params?: {
      /**
       * When true, returns full department details; otherwise only IDs.
       */
      details?: boolean;
    },
    context?: HttpContext
  ): Observable<GetDepartmentsOfLoggedInUserResponse> {
    return this.getAllDepartmentIdsOfLoggedInUser$Response(
      params,
      context
    ).pipe(
      map(
        (
          r: StrictHttpResponse<GetDepartmentsOfLoggedInUserResponse>
        ): GetDepartmentsOfLoggedInUserResponse => r.body
      )
    );
  }
}
